import { render, staticRenderFns } from "./ShipmentPrototypePaymentList.vue?vue&type=template&id=c6dc4430&scoped=true"
import script from "./ShipmentPrototypePaymentList.vue?vue&type=script&lang=js"
export * from "./ShipmentPrototypePaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dc4430",
  null
  
)

export default component.exports